// extracted by mini-css-extract-plugin
module.exports = {"heading":"Success_heading__3m_Zi","margin":"Success_margin__3cri4","button":"Success_button__3zEb0"};